import React from "react";
import "./MainLayout.scss";

const MainLayout = ({ children }) => {
  return (
    <div className="app-main-layout">
      <div className="desktop-info">
        <div className="content-wrapper">
          <h1 className="title">Simple. Fast. Digital Loans.</h1>
          <p className="description">
            Apply for loans digitally using LoanFront. Complete your
            application, Verify your Identity, and receive approval quickly.
          </p>
          <ul className="features-list">
            <li>
              <span>✓</span> Instant eligibility check
            </li>
            <li>
              <span>✓</span> Secure digital KYC
            </li>
            <li>
              <span>✓</span> Quick disbursal
            </li>
            <li>
              <span>✓</span> Real-time tracking
            </li>
          </ul>
        </div>
      </div>
      <div className="mobile-view-port">
        <div className="screen-content">
          <main className="main-scroll-area">{children}</main>
        </div>
      </div>
    </div>
  );
};

export default MainLayout;
